export default __webpack_public_path__ + "static/media/marking--discrete--give-way-single.88347f54.png";